/* eslint-disable */
/**
 * This was based from form.edit.mode.js
 */

export default function widgetAutoFill() {
  var isCardForm = !!window.CardForm;

  /**
   * Parse data for autofill
   */
  function parse(res) {
    window.$H(res).each(pair => {
      var qid = pair.key;
      var question = pair.value;
      try {
        switch (question.type) {
          case 'control_scale':
          case 'control_radio':
            // Emre: when session is used, "question.name" seems undefined in forms (42176)
            if (question.name == undefined) {
              var radios = window.$$(`#id_${qid} input[type="radio"]`);
            } else {
              var radios = document.getElementsByName(`q${qid}_${(question.type == 'control_radio' || question.type == 'control_scale') ? question.name : qid}`);
            }

            window.$A(radios).each(rad => {
              if (rad.value == question.value) {
                rad.checked = true;
                rad.writeAttribute('checked', 'checked');
                triggerChangeEvent(rad);
                rad.checked = true; // for ms edge
              } else if (question.items.other != null) {
                window.$(`other_${qid}`).checked = true;
                window.$(`other_${qid}`).writeAttribute('checked', 'checked');
                window.$(`input_${qid}`).value = question.items.other;
                triggerChangeEvent(window.$(`input_${qid}`));
                window.$(`input_${qid}`).checked = true; // for ms edge
              }
            });
            break;
          case 'control_checkbox':
            var checks = window.$$(`#id_${qid} input[type="checkbox"]`);
            window.$A(checks).each(chk => {
              chk.checked = false;
              chk.removeAttribute('checked');

              // if item selected do not include 'other', question.items is array. else, object
              if (Object.prototype.toString.call(question.items) === '[object Array]') {
                if (question.items.include(chk.value)) {
                  chk.checked = true;
                  chk.writeAttribute('checked', 'checked');
                  triggerChangeEvent(chk);
                  chk.checked = true; // for ms edge
                }
              } else {
                // question.items is object.  find a different means of getting data
                if (Object.values(question.items).include(chk.value)) {
                  chk.checked = true;
                  chk.writeAttribute('checked', 'checked');
                  triggerChangeEvent(chk);
                  chk.checked = true; // for ms edge
                } else if (question.items.other != null) {
                  window.$(`other_${qid}`).checked = true;
                  window.$(`other_${qid}`).writeAttribute('checked', 'checked');
                  window.$(`input_${qid}`).disabled = false;
                  window.$(`input_${qid}`).value = question.items.other;
                  triggerChangeEvent(chk);
                  window.$(`input_${qid}`).checked = true; // for ms edge
                }
              }
            });
            break;
          case 'control_yesno':
            var radioInputs = window.$$(`#id_${qid} input[type="radio"]`);
            window.$A(radioInputs).each(radio => {
              if (radio.value === question.value) {
                radio.checked = true;
                radio.writeAttribute('checked', 'checked');
                triggerChangeEvent(radio);
                radio.checked = true; // for ms edge
              }
            });
            break;
          case 'control_dropdown':
            var selectInput = window.$(`input_${qid}`);
            if (selectInput) {
              if (isCardForm) {
                var isMultiple = selectInput.up().querySelector('div.jfInput-dropdown')
                  .classList.contains('isMultiple');
                if (isMultiple) {
                  var selectedOptionValues = question.items[0].split(',');
                  selectedOptionValues.forEach(eachValue => {
                    selectInput.querySelector(`option[value="${eachValue}"]`).selected = true;
                  });
                } else {
                  selectInput.putValue(question.value);
                }
              } else if (selectInput.hasAttribute('multiple')) { // for multiple
                var options = window.$$(`#id_${qid} option`);
                window.$A(options).each(option => {
                  if (question.items.include(option.value)) {
                    option.selected = true;
                  }
                });
              } else { // for single
                selectInput.putValue(question.value);
              }

              selectInput.triggerEvent('change');
            }
            break;
          case 'control_rating':
            if (isCardForm) {
              var element = document.getElementById(`input_${qid}_${question.value}`);
              element.checked = true;
              triggerChangeEvent(element);
            } else if (window.$(`input_${qid}`)) {
              window.$(`input_${qid}`).setRating(question.value);
            }
            break;
          case 'control_datetime':
          case 'control_fullname':
            window.$H(question.items).each(item => {
              if (window.$(`${item.key}_${qid}`)) {
                (window.$(`${item.key}_${qid}`).value = item.value || '');
                window.$(`${item.key}_${qid}`).triggerEvent('change');
              }
            });
            if (window.$(`lite_mode_${qid}`)) {
              var date = question.items;
              if ('year' in date && 'month' in date && 'day' in date && date.year !== '' && date.month !== '' && date.day !== '') {
                JotForm.formatDate({
                  date: new Date(date.year, date.month - 1, date.day),
                  dateField: window.$(`id_${qid}`)
                });
              }
            }
            break;
          case 'control_emojislider':
            var cardWrapper = document.getElementById(`cid_${qid}`);
            var radioInputs = cardWrapper.querySelectorAll('input[type=radio]');
            var selectedIndex = 0;
            var radioInput;

            for (var i = 0; radioInput = radioInputs[i]; i++) {
              if (radioInput.value === question.value) {
                radioInput.checked = true;
                selectedIndex = i;
              }
            }

            var sliderWrapper = cardWrapper.querySelector('.js-emojiSlider');
            sliderWrapper.addClassName('isFilled');

            var sliderScaleList = sliderWrapper.querySelectorAll('.js-emojiScaleSep');
            var selectedScale = sliderScaleList[selectedIndex].getAttribute('data-scale');

            var faceListSlider = sliderWrapper.querySelector('.js-emojiSlider-faceList');
            faceListSlider.style.width = `${selectedScale}%`;

            var faces = faceListSlider.querySelectorAll('.js-emojiFaces');
            faces.forEach(eachFace => { eachFace.removeClassName('isVisible'); });
            faces[selectedIndex].addClassName('isVisible');
            break;
          case 'control_phone':
          case 'control_birthdate':
          case 'control_address':
          case 'control_time':
            window.$H(question.items).each(item => {
              if (window.$(`input_${qid}_${item.key}`)) {
                window.$(`input_${qid}_${item.key}`).putValue(item.value);
              }
            });
            if (question.type === 'control_time' && window.$(`input_${qid}_hourSelect`)) {
              var hourSelect = question.items.hourSelect ? question.items.hourSelect : '';
              if (hourSelect && window.$(`input_${qid}_hourSelect`).triggerEvent) {
                if (window.$(`input_${qid}_timeInput`)) {
                  if (hourSelect.length === 1 && hourSelect < 10) {
                    hourSelect = `0${hourSelect}`;
                    window.$(`input_${qid}_hourSelect`).putValue(hourSelect);
                  }
  
                  var minuteSelect = window.$(`input_${qid}_minuteSelect`).value;
                  if (minuteSelect.length === 1 && minuteSelect < 10) {
                    minuteSelect = `0${minuteSelect}`;
                  }
  
                  window.$(`input_${qid}_timeInput`).putValue(`${hourSelect}:${minuteSelect}`);
                } else { // handle values in old theme too
                  if (hourSelect.length === 2 && hourSelect.charAt(0) == '0') {
                    hourSelect = hourSelect.slice(1);
                    window.$(`input_${qid}_hourSelect`).putValue(hourSelect);
                  }
                }
                window.$(`input_${qid}_hourSelect`).triggerEvent('change'); 
              }
            }
            break;
          case 'control_email':
            var emailInput = window.$(`input_${qid}`);
            if (emailInput) {
              emailInput.putValue(question.value);
              emailInput.triggerEvent('change');

              // set confirm
              var emailInputConfirm = window.$(`input_${qid}_confirm`);
              if (emailInputConfirm) {
                emailInputConfirm.putValue(question.value);
                emailInputConfirm.triggerEvent('change');
              }
            }
            break;
          case 'control_textarea':
            if (question.value.length > 0) {
              var input = window.$(`input_${qid}`);
              // Set nicEditor content if exists
              if (input.up('div').down('.nicEdit-main') && nicEditors && nicEditors.findEditor(`input_${qid}`)) {
                nicEditors.findEditor(`input_${qid}`).setContent(question.value);
              }

              // Set input value
              input.putValue(question.value);
              triggerChangeEvent(input);

              if (isCardForm) { // ie8 & isCardForm Checks
                Array.prototype.forEach.call(CardForm.cards, (card, index) => {
                  if (card.question.id === qid && card.markdownEditor && card.markdownEditor.setHtmlFromMarkdown) {
                    // change the value to HTML syntax on edit mode
                    card.markdownEditor.setHtmlFromMarkdown();
                  }
                });
              }

              if (input.hasClassName('form-custom-hint')) {
                input.removeClassName('form-custom-hint').removeAttribute('spellcheck');
                input.hasContent = true;
                input.run('focus');
              }
            } else if (input.hasClassName('form-custom-hint')) {
              input.run('blur');
            }
            break;
          default:
            if (window.$(`input_${qid}`)) {
              window.$(`input_${qid}`).putValue(question.value);
              window.$(`input_${qid}`).triggerEvent('change');
            }
            break;
        }
      } catch (e) {
        // console.error(e);
      }
    });
  }

  function clear(res) {
    res.forEach(field => {
      var { qid } = field;
      var question = window.$(`input_${qid}`);
      var { type } = field;
      switch (type) {
        case 'control_scale':
        case 'control_radio':
          var radios = window.$$(`#id_${qid} input[type="radio"]`);
          window.$A(radios).each(rad => {
            rad.checked = false;
            rad.removeAttribute('checked');
            triggerChangeEvent(rad);
          });
          break;
        case 'control_checkbox':
          var checks = window.$$(`#id_${qid} input[type="checkbox"]`);
          window.$A(checks).each(chk => {
            chk.checked = false;
            chk.removeAttribute('checked');
            triggerChangeEvent(chk);
          });
          break;
        case 'control_yesno':
          break;
        case 'control_rating':
          if (isCardForm) {
            var radios = window.$$(`#id_${qid} input[type="radio"]`);
            window.$A(radios).each(rad => {
              if (rad.checked) {
                rad.checked = false;
                rad.click();
              }
            });
            window.$$(`#id_${qid} li`).invoke('removeClassName', 'checked');
            window.$$(`#id_${qid} input[type="hidden"]`).last().putValue('');
          } else {
            window.$(`input_${qid}`).setRating('');
          }
          break;
        case 'control_datetime':
        case 'control_fullname':
          window.$$(`input[id*=_${qid}]`).each(input => { input.putValue(''); });
          break;
        case 'control_emojislider':
          break;
        case 'control_phone':
        case 'control_birthdate':
        case 'control_address':
        case 'control_time':
          window.$$(`[id*=input_${qid}]`).each(input => {
            input.putValue('');
          });
          if (type === 'control_time' && window.$(`input_${qid}_hourSelect`) && window.$(`input_${qid}_hourSelect`).triggerEvent) {
            window.$(`input_${qid}_hourSelect`).triggerEvent('change');
          }
          break;
        case 'control_email':
        case 'control_textarea':
        case 'control_dropdown':
        default:
          if (question) {
            question.putValue('');
            question.triggerEvent('change');
            if (type === 'control_email') {
              // set confirm
              var emailInputConfirm = window.$(`input_${qid}_confirm`);
              if (emailInputConfirm) {
                emailInputConfirm.putValue('');
                emailInputConfirm.triggerEvent('change');
              }
            }
          }
          break;
      }
    });
  }

  function triggerChangeEvent(field) {
    if (field.type && field.type.match(/checkbox|radio/)) {
      var posX = window.scrollX;
      var posY = window.scrollY;
      ['click', 'change'].forEach(e => {
        field.triggerEvent(e);
      });
      // scroll back to avoid the "jump" effect
      if (posY !== window.scrollY) {
        window.scrollTo(posX, posY);
      }
      return;
    }
    field.triggerEvent('change');
  }

  /**
   * Generate prop items for each controls
   */
  function generateCtrlItems(qtype, value) {
    var items = {};

    // convert value to string
    value = `${value}`;

    switch (qtype) {
      case 'control_fullname':
        var name = value.replace(/^\s+|\s+$/g, '');
        name = name.split(/\s+/g);
        items = {
          first: name[0],
          last: name[1]
        };
        if (name.length == 3) {
          items.middle = name[1];
          items.last = name[2];
        }
        break;
      case 'control_checkbox':
      case 'control_dropdown':
        // split every comma, new line, br line
        items = value.split(/\r\n|\r|\n|\,|\<br\>/g);
        break;
      case 'control_phone':
        var number = value.split(/\s+/g);
        items = {
          area: number[0],
          phone: number[1],
          full: value
        };
        break;
      case 'control_time':
        // make sure a valid time
        if (/^([0]?\d|[1][0-2]):([0-5]\d)\s?(?:AM|PM)$/.test(value) || /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/.test(value)) {
          var timeParts = value.split(' ');
          if (timeParts.length > 0) {
            var time = timeParts[0].split(':');
            items = {
              ampm: timeParts[1],
              hourSelect: time[0],
              minuteSelect: time[1]
            };
          }
        }
        break;
    }

    return items;
  }

  return {
    parse: parse,
    clear: clear,
    generateCtrlItems: generateCtrlItems
  };
}
